import React from "react";
import PropTypes from "prop-types";


import Header from "./header";
import Footer from "./footer";

//anything between <> </> of a custom component gets passed as
//children prop.

const Layout = ({ children }) => ( 
  <>
    <Header/>
    <main className = "body">{children}</main>
    <Footer/>
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;
